var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.orderList.length === 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("暂无数据")]):_c('div',[_c('list-order',{attrs:{"getOrderList":_vm.getOrderList,"orderList":_vm.orderList}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d47266","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/Content.vue
// module id = null
// module chunks = 